module.exports = __webpack_public_path__ + "ff655146c11ae8ea54c1900f5db3dd01.svg";